import './styles.scss';

import { Currency } from '@enums/currency.enum';
import { Form, Input, Select } from 'antd';
import { Rule } from 'rc-field-form/lib/interface';

type CurrencyConfig = { prefix: string; currency: Currency };

type Props = {
    label: string;
    name: string;
    currencyConfig: CurrencyConfig;
    pricePlan: number;
    setCurrencyConfig: (arg: CurrencyConfig) => void;
    rules?: Array<Rule> | undefined;
    handlePriceChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const PriceFormItem: React.FC<Props> = ({
    label,
    name,
    currencyConfig,
    pricePlan,
    rules,
    setCurrencyConfig,
    handlePriceChange,
}) => {
    const prefixSelector = (
        <Form.Item name="currency" noStyle>
            <Select
                defaultValue={currencyConfig.currency}
                style={{ width: 80 }}
                onChange={(value: Currency) => onChangeCurrency(value)}
            >
                <Select.Option value={Currency.USD}>US</Select.Option>
                <Select.Option value={Currency.VND}>VND</Select.Option>
            </Select>
        </Form.Item>
    );

    const onChangeCurrency = (currency: Currency) => {
        switch (currency) {
            case Currency.USD:
                setCurrencyConfig({
                    currency: Currency.USD,
                    prefix: '$',
                });
                break;
            case Currency.VND:
                setCurrencyConfig({
                    currency: Currency.VND,
                    prefix: 'đ',
                });
                break;
        }
    };

    return (
        <Form.Item className="pricing-form-item" label={label} name={name} rules={rules}>
            <Input
                prefix={currencyConfig.prefix}
                addonBefore={prefixSelector}
                style={{ width: '100%' }}
                onChange={(e) => handlePriceChange?.(e)}
                value={pricePlan}
            />
        </Form.Item>
    );
};
